import React from 'react'
import { Route, Switch } from 'react-router-dom'
import { configuration } from '../../configuration'

export const AppWrapper = () => {
  const menuSimple = configuration.submenus.filter((x) => x.url !== '')

  configuration.submenus
    .filter((x) => x.items!.length > 0)
    .forEach(function (x) {
      x.items!.map((x) => menuSimple.push(x))
    })

  return (
    <Switch>
      {menuSimple.map((submenu) => {
        return (
          <Route
            key={submenu.name}
            path={`${configuration.url}/${submenu.url}`}
            component={submenu.component}
          />
        )
      })}
    </Switch>
  )
}
